<template>
    <div class="row">
        <h3>Maps</h3>
        <MapItem v-for="map in maps" v-bind:key="map.id" v-bind:map="map" @onMapClick="onMapClick" />
    </div>
</template>

<script lang="ts">
import MapItem from './MapItem.vue';

export default {
    name: 'MapList',
    display: 'Maps',
    components: {
        MapItem: MapItem,
    },
    props: {
        maps: {
            type: Array,
            default: function() {
                return [];
            },
        },
    },
    methods: {
        onMapClick: function({ map }) {
            this.$emit('onMapClick', { map });
        },
    },
};
</script>
